import { HttpEvent, HttpEventType } from '@angular/common/http';
import { Component, DoCheck, Input, OnChanges, OnDestroy, OnInit, SimpleChange, TemplateRef, ViewChild, ViewContainerRef, ViewRef } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { RequestService } from 'src/app/services/request.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.css']
})
export class ImageComponent implements OnInit, OnDestroy, OnChanges {
  @Input() id: string;
  @Input() alt: string;
  @Input() width: number;
  @Input() height: number;
  @Input() avatar: boolean;
  @Input() user: boolean;
  @Input() className: string;
  @Input() hasError: boolean;
  loaded: number = 0;
  safeResourceUrl: SafeResourceUrl;
  error: boolean = false;
  subscription: Subscription = new Subscription();

  prevID: string;

  private url: string;

  constructor(
    private sanitizer: DomSanitizer,
    private request: RequestService
  ) {
  }

  ngOnInit(): void {
    this.render();
  }
  ngOnChanges(changes): void {
    if (changes.id && changes.id.previousValue && changes.id.currentValue && changes.id.previousValue != changes.id.currentValue) {
      this.render();
    };
  }
  render(): void {
    if (this.id) {
      this.subscription.unsubscribe();
      const uri = this.user ? "user/avatar/" + this.id : "file/" + this.id;
      this.subscription = this.request.getProgress(environment.API_URL + uri, {}, 'blob')
      .pipe(
        map((response) => {
          if (response.type == HttpEventType.DownloadProgress)
            this.loaded = Math.floor(response.loaded / response.total * 100);
          if (response.body)
            return response.body;
        })
      )
      .subscribe(
        response => {
          if (!response) return;
          this.onLoad(response);
        },
        error => {
          this.error = true;
        }
      );
      return;
    }
    this.loaded = 100;
    this.safeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl('/assets/img/default-pic.png')
  }
  onLoad(image: Blob): void {
    this.url = URL.createObjectURL(image)
    this.safeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
  }
  ngOnDestroy(): void {
    URL.revokeObjectURL(this.url);
    this.subscription.unsubscribe();
  }
}
